import { selectBreeds } from '@app/store/core';
import { selectConsultationPatient, selectLastConsultation } from '@app/store/consultation/consultation.selectors';
import { Helper } from '@app/shared/utils';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { renalDetectFeatureKey } from '../renal-detect-feature-key';
import { RenalDetectState } from '../renal-detect.state';
import { selectCurrentBigMeasurementUnit } from '@app/store/vet';

const selectState = createFeatureSelector<RenalDetectState>(renalDetectFeatureKey);

export const selectSteps = createSelector(selectState, (state) => state.steps);
export const selectStep = createSelector(selectState, (state) => state.step);
export const selectEditMode = createSelector(selectState, (state) => state.editMode);

/**
 * Deprecated pet info selector for old components compatibilty
 */
export const selectRenalDetectPetSummary = createSelector(
  selectConsultationPatient,
  selectLastConsultation,
  selectBreeds,
  selectCurrentBigMeasurementUnit,
  (patient, lastConsulation, breeds, currentBigMeasurementUnit) =>
    !!patient &&
    !!lastConsulation &&
    Helper.patientToPetInfo(
      patient,
      lastConsulation,
      breeds?.find((b) => b.breedCode === patient.pet?.breedCode),
      currentBigMeasurementUnit,
    ),
);
